import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CmsHttpClient } from '@cms_root/app/api-clients/cms/cms-http-client.service';
import { environment } from '@cms_root/environments/environment';
import { ApiConfiguration } from '../models/api-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationApiService {
  private readonly apiConfigurationUrl = `${environment.cmsApi}api/configuration`;

  constructor(private readonly cmsHttpClient: CmsHttpClient) {}

  getConfiguration(): Observable<ApiConfiguration> {
    return this.cmsHttpClient.get<ApiConfiguration>(this.apiConfigurationUrl);
  }
}
